var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",class:{ header: _vm.title }},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.display)?_c('base-button',{attrs:{"variant":"tertiary","text":_vm.toggleFiltersLabel},on:{"click":function($event){return _vm.$emit('toggle-filters')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }